import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useRouterActions } from 'react-resource-router';

import { DELETE_BRANCH_PAGE } from 'src/redux/branches/actions/index';
import { DeleteBranchErrorTypes } from 'src/redux/branches/reducers/delete-branch-reducer';
import { getErrorType } from 'src/redux/branches/sagas/delete-branch-saga';
import { showFlagComponent } from 'src/redux/flags';
import urls from 'src/sections/repository/urls';
import { encodeBranchName } from 'src/urls/utils';
import authRequest from 'src/utils/fetch';

export function useDeleteBranch() {
  const dispatch = useDispatch();
  const { push } = useRouterActions();
  const deleteBranch = useCallback(
    async ({ branchName, owner, slug }: any) => {
      dispatch({
        type: DELETE_BRANCH_PAGE.REQUEST,
      });

      const endpoint = `${urls.api.v20.branches(
        owner,
        slug
      )}/${encodeBranchName(branchName)}`;
      try {
        const request = authRequest(endpoint, { method: 'DELETE' });
        const response = await fetch(request);
        if (response.ok) {
          dispatch({
            type: DELETE_BRANCH_PAGE.SUCCESS,
            payload: { branchName },
          });
          dispatch(showFlagComponent('delete-branch-success'));

          push(`/${owner}/${slug}/branches`);
        } else {
          const errorType = getErrorType(response.status);
          dispatch({
            type: DELETE_BRANCH_PAGE.ERROR,
            payload: {
              branchName,
              errorType,
            },
          });
          dispatch(showFlagComponent('delete-branch-error'));
        }
      } catch {
        dispatch({
          type: DELETE_BRANCH_PAGE.ERROR,
          payload: {
            branchName,
            errorType: DeleteBranchErrorTypes.GENERIC,
          },
        });
        dispatch(showFlagComponent('delete-branch-error'));
      }
    },
    [dispatch, push]
  );
  return deleteBranch;
}
